import React, { useEffect, useState } from 'react';

function shortVersion(value) {
  const match = String(value || '').match(/\b(\d+\.\d+\.\d+)\b/);
  return match ? `v${match[1]}` : '';
}

export default function ControllerVersionBadge() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await fetch('/api/control-status', {
          cache: 'no-store',
          credentials: 'same-origin'
        });
        if (!response.ok) return;
        const data = await response.json();
        if (!cancelled) setStatus(data);
      } catch (_) {}
    };

    load();
    const timer = window.setInterval(load, 10000);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  const version = shortVersion(status?.controllerVersion);
  if (!version) return null;

  const connected = Boolean(status?.connected);
  const updater = status?.updaterStatus || null;
  const updaterState = String(updater?.state || '').toLowerCase();

  let label = version;
  let color = connected ? '#8de3ac' : '#71847a';
  let dot = connected ? '#49d17d' : '#53645c';

  if (connected && ['validating', 'installing'].includes(updaterState)) {
    label = `${version} · updating`;
    color = '#9fc8ff';
    dot = '#65a9ff';
  } else if (connected && updaterState === 'waiting') {
    const pending = shortVersion(updater?.pendingVersion);
    label = pending ? `${version} · ${pending} pending` : `${version} · update pending`;
    color = '#f6c677';
    dot = '#f2ad4b';
  } else if (connected && updaterState === 'error') {
    label = `${version} · updater`;
    color = '#ff9894';
    dot = '#ff6b67';
  }

  const titleParts = [String(status?.controllerVersion || version)];
  if (updater) {
    titleParts.push(`Updater: ${updater.state || 'unknown'}`);
    if (updater.pendingVersion) titleParts.push(`Pending: ${updater.pendingVersion}`);
    if (updater.lastInstalledVersion) titleParts.push(`Last installed: ${updater.lastInstalledVersion}`);
    if (updater.lastError) titleParts.push(`Error: ${updater.lastError}`);
  }

  return (
    <div
      title={titleParts.join(' · ')}
      aria-label={`TeleStaff controller ${label}${connected ? ', connected' : ', offline'}`}
      style={{
        position: 'fixed',
        right: 12,
        bottom: 12,
        zIndex: 40,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 9px',
        borderRadius: 999,
        border: '1px solid rgba(255,255,255,.08)',
        background: 'rgba(7,16,13,.90)',
        boxShadow: '0 8px 24px rgba(0,0,0,.18)',
        color,
        fontFamily: 'Inter,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
        fontSize: 10,
        fontWeight: 850,
        letterSpacing: '.06em',
        pointerEvents: 'none',
        backdropFilter: 'blur(8px)'
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: dot
        }}
      />
      {label}
    </div>
  );
}
